import Bloc from './Bloc.js';
import Types from './Types.js';

export default class CompareStatuses extends Bloc {

	constructor (src, ctx) {

		super("cmpstatuses", src, ctx);
		this.f = (src, ins, props) => {
			return [ins[0] === ins[1]];
		}
		this.types = [Types.string, Types.string];
	}
}